
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"invalid.hierarchy.title":"Ungültige Hierarchie","reset":"Zurücksetzen"},"en":{"invalid.hierarchy.title":"Invalid Hierarchy","reset":"Reset"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();